<div class="floor-map-wrapper">
  <div #floorMap class="map-container map-collapsed" [class.has-floorplan]="!!floorMapEntity?.floorplanId"></div>

  @if (isLoading) {
    <div class="loader-overlay">
      <div class="spinner-border text-light me-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="fw-bold text-white">Loading 3D Floor...</span>
    </div>
  }
</div>